import React, { useState, useEffect } from "react";
import AutoComplete from "../../common/autocomplete/AutoComplete";

const EmployeeSearch = ({ 
    employeeList, 
    isLoading, 
    onSelect, 
    preselectedEmployee = null,
    useRsEmployeeId = false
}) => {
    const [selectedEmp, setSelectedEmp] = useState(preselectedEmployee);

    useEffect(() => {
        // Update selected employee if preselected employee changes
        if (preselectedEmployee) {
            setSelectedEmp(preselectedEmployee);
        }
    }, [preselectedEmployee]);

    const empSelectedHandler = (emp) => {
        setSelectedEmp(emp);
        if (onSelect) {
            // If useRsEmployeeId is true and rs_EmployeeId exists, transform the employee object
            if (useRsEmployeeId && emp && emp.rs_EmployeeId) {
                // Create a new object with employeeId pointing to rs_EmployeeId for downstream components
                const modifiedEmp = {
                    ...emp,
                    employeeId: emp.rs_EmployeeId
                };
                onSelect(modifiedEmp);
            } else {
                onSelect(emp);
            }
        }
    };

    return (
        <>
            {!isLoading ? (
                <AutoComplete
                    onSelect={empSelectedHandler}
                    suggestions={employeeList}
                    preselected={selectedEmp}
                />
            ) : (
                <div>Loading employees...</div>
            )}
        </>
    );
};

export default EmployeeSearch;